import { IntegrationCheckOwner } from "@freightsimple/generated-hubble-openapi-client/models/IntegrationCheckOwner";
import { IntegrationCheckStatus } from "@freightsimple/generated-hubble-openapi-client/models/IntegrationCheckStatus";
import type { BigCommerceHealthcheckResult } from "@freightsimple/generated-hubble-openapi-client/models/BigCommerceHealthcheckResult";

// BigCommerce healthcheck (ENG-7381), in its own module for the same reason as Shopify's: a
// realistic result would put integrationsInlineResponses.tsx over the 400-line limit.
//
// Deliberately mixed — a fail, a warn, an inferred check and a pass — because the dialog's job is
// to say *which* prerequisite is wrong, and an all-green mock would document nothing.
export const BIGCOMMERCE_HEALTHCHECK_RESPONSE: BigCommerceHealthcheckResult = {
  storeHash: "x7k2m9qa",
  linkState: "linked",
  ok: false,
  items: [
    {
      id: "link_state",
      name: "Store linked",
      status: IntegrationCheckStatus.Pass,
      detail: "Linked",
      owner: IntegrationCheckOwner.Merchant,
      inferred: false,
    },
    {
      id: "credentials_readable",
      name: "Credentials usable",
      status: IntegrationCheckStatus.Pass,
      detail: "Readable, with a connection key and a webhook secret",
      owner: IntegrationCheckOwner.FreightSimple,
      inferred: false,
    },
    {
      id: "config_readable",
      name: "Config readable",
      status: IntegrationCheckStatus.Pass,
      detail: "Readable",
      owner: IntegrationCheckOwner.FreightSimple,
      inferred: false,
    },
    {
      id: "quoting_blocked",
      name: "Company can quote",
      status: IntegrationCheckStatus.Pass,
      detail: "Not blocked",
      owner: IntegrationCheckOwner.FreightSimple,
      inferred: false,
    },
    {
      id: "rates_enabled",
      name: "Rates switched on",
      status: IntegrationCheckStatus.Warn,
      detail:
        "Paused by the merchant — checkout shows no FreightSimple rates until they switch them back on",
      owner: IntegrationCheckOwner.Merchant,
      inferred: false,
    },
    {
      id: "settings_valid",
      name: "Settings valid",
      status: IntegrationCheckStatus.Pass,
      detail: "Every setting passes the checks a save runs",
      owner: IntegrationCheckOwner.Merchant,
      inferred: false,
    },
    {
      id: "rate_requests",
      name: "BigCommerce asks us for rates",
      status: IntegrationCheckStatus.Pass,
      detail: "Last rate request 2026-09-30 18:12 UTC",
      owner: IntegrationCheckOwner.Merchant,
      inferred: true,
    },
    {
      id: "store_reachable",
      name: "Store reachable with its token",
      status: IntegrationCheckStatus.Pass,
      detail: "BigCommerce answered",
      owner: IntegrationCheckOwner.Merchant,
      inferred: false,
    },
    {
      id: "webhooks_recorded",
      name: "Order webhooks recorded",
      status: IntegrationCheckStatus.Pass,
      detail: "All 2 order scopes recorded",
      owner: IntegrationCheckOwner.FreightSimple,
      inferred: false,
    },
    {
      id: "webhooks_live",
      name: "Order webhooks delivering here",
      status: IntegrationCheckStatus.Fail,
      detail:
        "store/order/updated was switched off by BigCommerce. Order events stop reaching us. Disconnect the store in Hubble, then have the merchant reinstall the app in BigCommerce and press Connect. That issues a new connection key, which they paste into the FreightSimple carrier in their BigCommerce shipping settings",
      owner: IntegrationCheckOwner.FreightSimple,
      inferred: false,
    },
  ],
};
